// Module Import
//---------------------------------
import React from 'react'
import styled from 'styled-components'
import ImageCut from '../../../assets/images/graphic_imageCut.svg'
import {brandDarkGrey, brandIvory, brandOrange} from '../../../assets/consts/color'

// Component Import
//---------------------------------

// Styled Component Declarations
//---------------------------------

const PageSummaryListItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin: 0 0 24px 0;
    
    @media only screen and (min-width: 90em) {
        margin: 0;
        &:not(:last-child) {
            border-right: 4px solid ${brandOrange};
        }
    }
`

const PageSummaryListItemLink = styled.a`
    cursor: pointer;
    text-decoration: none;
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin: 0 0 24px 0;

    & > div {
        transition: .2s ease-in-out;

        &:hover {
            background-color: rgba(251, 115, 71, 0.3);
        }
    }

    @media only screen and (min-width: 90em) {
        margin: 0;
        &:not(:last-child) {
            border-right: 4px solid ${brandOrange};
        }
    }
`


const CopyWrapper = styled.div`
    background-color: ${(props) => props.variant === "primary" ? brandIvory : "none"};
    border-bottom: ${(props) => props.variant === "primary" ? "2px solid #00000012" : "none"};
    border-radius: 4px;
    display: flex;
    flex: 1 1 0%;
    flex-direction: column;
    margin: 0;
    padding: ${(props) => props.variant === "primary" ? "40px 48px" : "8px"};
    position: relative;
    max-height: 100%;
    
    &:after {
        display: ${(props) => props.variant === "primary" ? "block" : "none"};
        background-image: url(${ImageCut});
        background-position: top left;
        background-size: cover;
        content: '';
        height: 30px;
        left: 0;
        position: absolute;
        top: 0;
        transform: rotate(-180deg);
        width: 30px;
        z-index: 1;
    }

    h4 {
        margin: 0 0 8px 0;
        font-weight: bold;
        color: ${(props) => props.variant === "primary" ? brandOrange : brandDarkGrey};
    }

    p {
        scrollbar-width: thin;
        overflow: auto;
        margin: 0;
    }
`


// Component Export
//---------------------------------
export default function PageSummaryItem({
    title,
    body,
    variant = "primary",
    link,
  }) {
  if(link){
    return (
      <PageSummaryListItemLink className="col-xs-12 col-md-6 col-lg-4" href={link}>
        <CopyWrapper variant={variant}>
          <h4>{title}</h4>
          <p>{body}</p>
        </CopyWrapper>
      </PageSummaryListItemLink>
    )
  }

  return (
    <PageSummaryListItem className="col-xs-12 col-md-6 col-lg-4">
      <CopyWrapper variant={variant}>
        <h4>{title}</h4>
        <p>{body}</p>
      </CopyWrapper>
    </PageSummaryListItem>
  )
}

PageSummaryItem.propTypes = {}
